import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

// Mobile bottom sheet holding the facet rail. Locks body scroll while open and
// closes on backdrop tap / Escape.
const FiltersSheet = ({ onClose, onClearAll, children }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div className="ab-sheet-backdrop" onClick={onClose}>
      <div className="ab-sheet" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Filters">
        <div className="ab-sheet__head">
          <span className="ab-sheet__title">Filters</span>
          <button type="button" className="ab-sheet__close" aria-label="Close filters" onClick={onClose}>✕</button>
        </div>
        <div className="ab-sheet__body">{children}</div>
        <div className="ab-sheet__foot">
          <button type="button" className="ab-clear" onClick={onClearAll}>Clear all</button>
          <button type="button" className="ab__add" onClick={onClose}>Done</button>
        </div>
      </div>
    </div>
  );
};
FiltersSheet.propTypes = {
  onClose: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default FiltersSheet;
